import {
  FILLABLE_CHECKBOX_TYPE,
  FILLABLE_COMBO_BOX_TYPE,
  FILLABLE_COMBOBOX_GROUP_TYPE,
  FILLABLE_RADIO_BUTTON_TYPE,
  FILLABLE_SIGNATURE_TYPE,
  FILLABLE_TEXT_INPUT_TYPE,
} from './complexDocumentConstants';
import { random4Characters } from './javascript';

export const getRandomFieldName = type => {
  const FILLABLE_RANDOM_FIELDNAME = {
    [FILLABLE_CHECKBOX_TYPE]: `check-box-${random4Characters()}`,
    [FILLABLE_COMBO_BOX_TYPE]: `combobox-${random4Characters()}`,
    [FILLABLE_RADIO_BUTTON_TYPE]: `radio-button-${random4Characters()}`,
    [FILLABLE_TEXT_INPUT_TYPE]: `text-box-${random4Characters()}`,
    [FILLABLE_SIGNATURE_TYPE]: `signature-${random4Characters()}`,
    [FILLABLE_COMBOBOX_GROUP_TYPE]: `combobox-group-${random4Characters()}`,
  };
  return FILLABLE_RANDOM_FIELDNAME[type];
};
